import React, { useEffect, useState } from "react";

const API = "https://api.haymestasarim.com/api";

export default function ReferansResetPasswordPage() {
  const [token, setToken] = useState(null);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  /* =====================================================
     🔐 TOKEN OKUMA (HASH ROUTER UYUMLU)
     #/network-passport/reset-password?token=XXX
  ===================================================== */
  useEffect(() => {
    const hash = window.location.hash;

    if (!hash || !hash.includes("?")) {
      setMessage({
        type: "error",
        text:
          "Geçersiz bağlantı. Lütfen şifre sıfırlama işlemini yeniden başlatın.",
      });
      return;
    }

    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    const t = params.get("token");

    if (!t) {
      setMessage({
        type: "error",
        text:
          "Güvenlik hatası: Şifre sıfırlama anahtarı bulunamadı.",
      });
      return;
    }

    setToken(t);
  }, []);

  /* =====================================================
     🔐 ŞİFRE GÜÇ KONTROLÜ
  ===================================================== */
  const isStrongPassword = (pwd) => {
    return (
      pwd.length >= 8 &&
      /[A-Z]/.test(pwd) &&
      /[a-z]/.test(pwd) &&
      /[0-9]/.test(pwd)
    );
  };

  /* =====================================================
     🔐 SUBMIT
  ===================================================== */
  const submit = async () => {
    if (!token) {
      setMessage({
        type: "error",
        text:
          "Güvenlik hatası. Bu işlem için geçerli bir bağlantı gereklidir.",
      });
      return;
    }

    if (!password || !password2) {
      setMessage({
        type: "error",
        text: "Tüm alanlar zorunludur.",
      });
      return;
    }

    if (password !== password2) {
      setMessage({
        type: "error",
        text: "Şifreler uyuşmuyor.",
      });
      return;
    }

    if (!isStrongPassword(password)) {
      setMessage({
        type: "error",
        text:
          "Şifre en az 8 karakter olmalı, büyük harf, küçük harf ve rakam içermelidir.",
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(
        `${API}/network-passport/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            password,
          }),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setMessage({
          type: "success",
          text:
            "Şifreniz başarıyla güncellendi. Artık güvenli bir şekilde giriş yapabilirsiniz.",
        });
      } else {
        setMessage({
          type: "error",
          text:
            data?.message ||
            "Bağlantı geçersiz veya süresi dolmuş olabilir.",
        });
      }
    } catch (err) {
      setMessage({
        type: "error",
        text:
          "Sunucuya ulaşılamadı. Lütfen daha sonra tekrar deneyin.",
      });
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     🧱 UI
  ===================================================== */
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={{ marginBottom: 6 }}>Yeni Şifre Oluştur</h2>
        <p style={styles.sub}>
          Referans / Panel hesabınız için yeni bir şifre belirleyin
        </p>

        {message && (
          <div
            style={{
              ...styles.message,
              background:
                message.type === "error"
                  ? "#fee2e2"
                  : "#dcfce7",
              color:
                message.type === "error"
                  ? "#991b1b"
                  : "#166534",
            }}
          >
            {message.text}
          </div>
        )}

        {!message || message.type !== "success" ? (
          <>
            <input
              type="password"
              style={styles.input}
              placeholder="Yeni Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              type="password"
              style={styles.input}
              placeholder="Yeni Şifre (Tekrar)"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
            />

            <button
              style={{
                ...styles.btn,
                opacity: loading ? 0.7 : 1,
              }}
              onClick={submit}
              disabled={loading}
            >
              {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}

/* =====================================================
   🎨 STYLES
===================================================== */

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f8fafc",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  card: {
    width: 400,
    background: "#fff",
    padding: 30,
    borderRadius: 18,
    boxShadow: "0 20px 45px rgba(0,0,0,.15)",
    textAlign: "center",
  },
  sub: {
    color: "#64748b",
    marginBottom: 22,
    fontSize: 14,
  },
  input: {
    width: "100%",
    padding: 14,
    borderRadius: 10,
    border: "1px solid #d1d5db",
    marginBottom: 12,
    fontSize: 14,
  },
  btn: {
    width: "100%",
    padding: 14,
    borderRadius: 10,
    background: "linear-gradient(90deg,#2563eb,#f97316)",
    color: "#fff",
    fontWeight: 700,
    border: "none",
    cursor: "pointer",
    marginTop: 10,
    fontSize: 15,
  },
  message: {
    padding: 12,
    borderRadius: 10,
    marginBottom: 16,
    fontWeight: 600,
    fontSize: 14,
  },
};
